import React from "react";
import FieldRow from "../FieldRow";
import ProductsList from "../ProductsList";

export default function RouteResultCard({ item, isExpanded, onCopy }) {
  const receipts = item.receipts || [];
  const totalProducts = receipts.reduce(
    (acc, r) => acc + (Array.isArray(r.products) ? r.products.length : 0),
    0
  );

  return (
    <>
      <div style={{ display: "grid", gap: "0.25rem", marginTop: "0.4rem" }}>
        <FieldRow label="ID" value={item.id} onCopy={onCopy} />
        <FieldRow label="Дата" value={item.route_date} onCopy={onCopy} />
        <FieldRow
          label="Время"
          value={
            item.time_from || item.time_to
              ? `${item.time_from || "—"} - ${item.time_to || "—"}`
              : ""
          }
          onCopy={onCopy}
        />
        <FieldRow label="Статус" value={item.route_status} onCopy={onCopy} />
        <FieldRow label="Водитель" value={item.driver} onCopy={onCopy} />
        <FieldRow label="Оператор" value={item.operator} onCopy={onCopy} />
        <FieldRow label="Автомобиль" value={item.car} onCopy={onCopy} />
        <FieldRow label="Районы" value={item.route_districts} onCopy={onCopy} />
        <FieldRow
          label="Готов к выгрузке"
          value={item.is_ready_for_upload ? "Да" : "Нет"}
          onCopy={onCopy}
        />
        <FieldRow
          label="Выгружен"
          value={item.is_uploaded ? "Да" : "Нет"}
          onCopy={onCopy}
        />
      </div>

      <div
        style={{
          marginTop: "0.6rem",
          fontSize: "0.8rem",
          color: "#64748b",
        }}
      >
        Квитанций: <strong>{receipts.length}</strong> · Товаров:{" "}
        <strong>{totalProducts}</strong>
      </div>

      {isExpanded && receipts.length > 0 && (
        <div
          style={{
            marginTop: "0.6rem",
            borderTop: "1px solid #e2e8f0",
            paddingTop: "0.5rem",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          {receipts.map((r) => (
            <div
              key={r.id}
              style={{
                borderRadius: "0.5rem",
                border: "1px solid #e2e8f0",
                padding: "0.5rem 0.6rem",
                background: "#f9fafb",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.25rem",
                }}
              >
                <span style={{ fontSize: "0.85rem", fontWeight: 600 }}>
                  Квитанция {r.receipt_number || r.id}
                </span>
                <span
                  style={{
                    fontSize: "0.7rem",
                    padding: "0.1rem 0.35rem",
                    borderRadius: "999px",
                    background: "#eff6ff",
                    color: "#1d4ed8",
                  }}
                >
                  {r.status || "—"}
                </span>
              </div>
              <FieldRow label="ID" value={r.id} onCopy={onCopy} />
              <FieldRow label="Клиент" value={r.client_name} onCopy={onCopy} />
              <FieldRow label="Договор" value={r.contract_number} onCopy={onCopy} />
              <FieldRow label="Адрес" value={r.delivery_address} onCopy={onCopy} />
              <FieldRow label="Телефон" value={r.phone_number} onCopy={onCopy} />
              <FieldRow label="Сумма" value={r.amount} onCopy={onCopy} />

              {Array.isArray(r.products) && r.products.length > 0 && (
                <div style={{ marginTop: "0.3rem" }}>
                  <span
                    style={{
                      fontSize: "0.75rem",
                      color: "#94a3b8",
                      display: "block",
                      marginBottom: "0.15rem",
                    }}
                  >
                    Товары:
                  </span>
                  <ProductsList products={r.products} onCopy={onCopy} />
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </>
  );
}
